import { memo } from 'react';
import { Box, Text } from '@mantine/core';
import { TaskDescriptionProps } from '../TaskGeneralInfo.types';
import styles from '../TaskGeneralInfo.module.css';

export const TaskDescription = memo(function TaskDescription({
  description,
  isMobile,
}: TaskDescriptionProps) {
  if (!description || description.trim() === '') {
    return null;
  }

  return (
    <Box
      className={`${styles.descriptionSectionStandalone} ${isMobile ? styles.descriptionSectionMobile : ''}`}
    >
      <Box
        className={`${styles.descriptionContent} ${isMobile ? styles.descriptionContentMobile : ''}`}
      >
        <Text size="sm" className={styles.descriptionText}>
          {description}
        </Text>
      </Box>
    </Box>
  );
});